import { CollectionSiteQueryParams } from '../types/collection-site.type';
import { HttpMethods, makeRequest } from '../helpers/http.helper';

export const getCollectionSites = (params: CollectionSiteQueryParams) => {
  const { organization_id, ...otherParams } = params;
  return makeRequest({
    url: `/collection_site/${organization_id}`,
    method: HttpMethods.GET,
    params: otherParams,
  });
};
